<template>
  <div>
    <b-modal
      :title="$t('Review Justification')"
      size="lg"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      v-model="show"
      @hidden="$emit('hidden')"
    >
      <b-row class="my-1">
        <b-col cols="6" lg="6" md="6" sm="12" xs="12">
          <validation-provider v-slot="{ errors }" name="justification_type">
            <b-form-group
              :label="$t('Employee')"
              :state="errors[0] ? false : null"
            >
              <b-form-input v-model="justification.personal_name" disabled />
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="6" lg="6" md="6" sm="12" xs="12">
          <validation-provider v-slot="{ errors }" name="justification_type">
            <b-form-group
              :label="$t('Justification Type')"
              :state="errors[0] ? false : null"
            >
              <v-select
                v-model="justification.justification_type_id"
                id="justification_type"
                :clearable="false"
                :reduce="(value) => value.id"
                label="name"
                :options="justificationTypes"
                :get-option-label="(option) => $t(option.name)"
                disabled
              >
              </v-select>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="6" lg="6" md="6" sm="12" xs="12">
          <validation-provider name="start_date">
            <b-form-group :label="$t('Date')">
              <kendo-datepicker
                class="form-control-kendo"
                :format="'dd-MM-yyyy'"
                v-model="justification.date"
                autofocus
                :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                :disabled="true"
              />
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col
          cols="6"
          lg="6"
          md="6"
          sm="12"
          xs="12"
          v-if="justification.url_file != null"
        >
          <validation-provider name="start_date">
            <b-form-group :label="$t('File')">
              <a
                :href="justification.url_file"
                target="_blank"
                class="btn btn-outline-primary btn-sm w-100"
                :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                :disabled="true"
              >
                <feather-icon icon="DownloadIcon" size="16" class="mr-1" />
                {{ $t("Download") }}
              </a>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col v-if="esTardanza" cols="6" lg="6" md="6" sm="12" xs="12">
          <validation-provider name="aplicar_descuento">
            <b-form-group label="¿Aplicar descuento por tardanza?">
              <b-form-checkbox
                class="mt-05"
                v-model="justification.aplicar_descuento"
                switch
              ></b-form-checkbox>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12">
          <validation-provider v-slot="{ errors }" name="observation">
            <b-form-group
              :label="$t('Observation')"
              :state="errors[0] ? false : null"
            >
              <b-form-textarea
                v-model="justification.observation"
                :rows="3"
                :max-rows="6"
                disabled
              ></b-form-textarea>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" class="d-flex justify-content-end mt-2" v-if="!isView">
          <b-button
            variant="outline-danger"
            class="mr-1"
            @click="updateJustification(3)"
          >
            {{ $t("Reject") }}
            <feather-icon icon="XIcon" size="16" />
          </b-button>

          <b-button variant="outline-success" @click="updateJustification(2)">
            {{ $t("Approve") }}
            <feather-icon icon="CheckIcon" size="16" />
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import AttendanceService from "@/views/rrhh/views/attendance/services/attendance.service.js";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  props: {
    justifiationId: {
      type: Number,
      required: true,
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: true,
      dates: [],
      justificationTypes: [],
      justification: {
        justification_type_id: "",
        observation: "",
        employee_id: "",
        created_by: "",
        file: null,
        date: "",
        aplicar_descuento: false,
      },
    };
  },
  mounted() {
    // this.listJustificationTypes();
    // this.getJustification();
    this.addPreloader();
    Promise.all([this.listJustificationTypes(), this.getJustification()]);
    this.removePreloader();
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    esTardanza() {
      return this.justification.justification_type_id == 3;
    },
  },
  methods: {
    async listJustificationTypes() {
      try {
        const { data } = await AttendanceService.listJustificationTypes();
        this.justificationTypes = data;
      } catch (error) {
        this.showToastError();
      }
    },

    async getJustification() {
      try {
        const { data } = await AttendanceService.getJustification({
          id: this.justifiationId,
        });
        this.justification = data[0];
        this.justification.aplicar_descuento =
          this.justification.aplicar_descuento === 1 ? true : false;
      } catch (error) {
        this.showToastError(error);
      }
    },

    async updateJustification(status) {
      try {
        this.addPreloader();

        let payload = {
          id: this.justifiationId,
          justification_type_id: this.justification.justification_type_id,
          employee_id: this.justification.employee_id,
          updated_by: this.currentUser.id,
          observation: this.justification.observation,
          _method: "PUT",
          status,
          start_date: moment(this.justification.date).format("YYYY-MM-DD"),
        };

        if (this.esTardanza) {
          payload.aplicar_descuento =
            this.justification.aplicar_descuento === true ? 1 : 0;
        }

        const { data } = await AttendanceService.updateJustification(payload);
        this.justification = data[0];
        this.showToastSuccess(this.$t(data[0].Message));
        this.$emit("updated");
        console.log(data);
      } catch (error) {
        this.showToastError(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>